import z from 'zod';
import { ATTACHMENTS_PRESIGNED_URL_MODULES } from '../enums';

// POST -> /api/core/attachments/presign/
export const postAttachmentsPresignedUrls = {
  body: z.array(
    z.object({
      module: z.enum(ATTACHMENTS_PRESIGNED_URL_MODULES),
      filename: z.string().nonempty({ error: 'Filename is required' }),
      content_type: z.string().nonempty({ error: 'Content type is required' }),
      size: z.number().int().nonnegative().optional(),
    }),
  ),
  response: z.array(
    z.object({
      filename: z.string(),
      upload_url: z.url(),
      file_url: z.url(),
      key: z.string(),
    }),
  ),
  params: z.never(),
  query: z.never(),
};
const postAttachmentsPresignedUrlsSchema = z.object(
  postAttachmentsPresignedUrls,
);
export type PostAttachmentsPresignedUrls = z.infer<
  typeof postAttachmentsPresignedUrlsSchema
>;

// GET -> /api/core/parts/
export const getPartsListByProjectAndRelease = {
  body: z.never(),
  response: z
    .object({
      id: z.number(),
      part_number: z.string(),
    })
    .array(),
  params: z.never(),
  query: z
    .object({
      project: z.union([z.coerce.number().min(1), z.undefined()]),
      release: z.union([z.coerce.number().min(1), z.undefined()]),
    })
    .optional(),
};
const getPartsListByProjectAndReleaseSchema = z.object(
  getPartsListByProjectAndRelease,
);
export type GetPartsListByProjectAndRelease = z.infer<
  typeof getPartsListByProjectAndReleaseSchema
>;
